import Tooltip from '../../../atoms/display/tooltip'

import React, { memo } from 'react'

import { InfoRounded as InfoIcon } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core'

function TooltipInfo() {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <>
      <Tooltip
        title={
          <>
            {t('info.treeOfKnowledge.search')}
            <br /> <br />
            {t('info.treeOfKnowledge.select')}
          </>
        }
      >
        <InfoIcon style={{ color: theme.palette.primary.dark, marginRight: 10 }} />
      </Tooltip>
    </>
  )
}

export default memo(TooltipInfo)
